// src/order.ts
var CASHIER_ACTIONS = {
  // [OrderStatus.placed]: [
  //   { status: OrderStatus.accepted, text: "accept", style: "success" },
  //   { status: OrderStatus.rejected, text: "reject", style: "danger" },
  //   { status: OrderStatus.canceled, text: "cancel", style: "danger" },
  // ],
  // [OrderStatus.accepted]: [
  //   { status: OrderStatus.ready, text: "mark as ready", style: "success" },
  //   { status: OrderStatus.canceled, text: "cancel", style: "danger" },
  //   { status: OrderStatus.rejected, text: "reject", style: "danger" },
  // ],
  // [OrderStatus.ready]: [
  //   { status: OrderStatus.done, text: "mark as done", style: "success" },
  //   { status: OrderStatus.rejected, text: "reject", style: "danger" },
  // ],
  // [OrderStatus.done]: [],
  // [OrderStatus.canceled]: [],
  // [OrderStatus.rejected]: [],
};

export {
  CASHIER_ACTIONS
};
